module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium-WebXL.4977bd0.woff2";